import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollEffect } from "@/hooks";
import { AdSlotIds } from "@/shared/types";
import { Box } from "@gemini/core";
import { useRef } from "react";
import { useShowAds } from "../hooks/useShowAds";
import { AdContainer } from "./AdContainer";
import { useIsPubstackEnabled } from "../utils/utils";
export const MediumRectangles = ({ initialTopOffset = 150, }) => {
    const adRectangle1 = useRef(null);
    const adRectangle2 = useRef(null);
    const containerRef = useRef(null);
    const { pinnedAd1, ad1Top } = useScrollEffect(
    // @ts-ignore
    adRectangle1, adRectangle2, containerRef);
    const { showSection } = useShowAds();
    const showMediumRectangles = showSection([
        AdSlotIds.AD_MEDIUM_RECTANGLE_1,
        AdSlotIds.AD_MEDIUM_RECTANGLE_2,
    ]);
    const isPubstackEnabled = useIsPubstackEnabled();
    if (isPubstackEnabled && !showMediumRectangles) {
        return null;
    }
    return (_jsxs(Box, { display: showMediumRectangles ? "flex" : "none", flex: "1", minHeight: "0", alignItems: "center", flexDirection: "column", ref: containerRef, unsafe_className: "HideOnPrint", children: [_jsx(Box, { position: pinnedAd1 ? "relative" : "sticky", top: pinnedAd1 ? ad1Top : initialTopOffset, ref: adRectangle1, display: "flex", children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_MEDIUM_RECTANGLE_1, display: {
                        "breakpoint.base": "none",
                        "breakpoint.lg": "flex",
                    }, showLabel: true, width: "300px", justifyContent: "center" }) }), _jsx(Box, { minHeight: "25%", width: "100%" }), _jsx(Box, { ref: adRectangle2, display: "flex", position: "sticky", top: initialTopOffset, children: _jsx(AdContainer, { adSlotId: AdSlotIds.AD_MEDIUM_RECTANGLE_2, display: {
                        "breakpoint.base": "none",
                        "breakpoint.lg": "flex",
                    }, showLabel: true, width: "300px", justifyContent: "center" }) })] }));
};
